import { RootState } from "../types";
import {
  AiCreditsData,
  FeatureQuotaData,
  RestrictionType,
} from "../slices/accessControl.slice";

export const restrictionTypeSelector = (state: RootState): RestrictionType =>
  state.accessControl.type;

export const restrictionCodeSelector = (state: RootState): string | null =>
  state.accessControl.code;

export const quotaDataSelector = (state: RootState): FeatureQuotaData | null =>
  state.accessControl.quotaData;

export const aiCreditsDataSelector = (state: RootState): AiCreditsData | null =>
  state.accessControl.creditsData;
